module.exports = __webpack_public_path__ + "static/media/Problem solving through Programming In C.a5d7bc5a.jpg";